import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const base64Eval: Example = {
  id: "base64-eval",
  title: "Base64 payload via eval",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "eval(atob('…')) hides a beacon: the decoded payload appears as layer 1",
  explainer:
    "The source is just a base64 string and `eval(atob(p))`. Running it reveals the decoded payload as **layer 1** (open its tab from the `codegen` row), and the beacon it sends is attributed to layer 1, line 3, not to the loader.",
  code,
  expect: golden as Example["expect"],
};
